import { useState } from "react";

const PRESETS = [
  "#ffffff", "#0F0F0F", "#145A43", "#D7C7A1", "#2F8F6F",
  "#F5F5F5", "#1E1E1E", "#FFE4C4", "#DDEEFF", "#FFD1DC",
];

function isValidHex(v) {
  return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v || "");
}

export default function BackgroundControl({ backgroundColor, onChange }) {
  const isTransparent = backgroundColor === null;
  const [hexInput, setHexInput] = useState(backgroundColor || "#ffffff");

  const handleHexSubmit = () => {
    if (isValidHex(hexInput)) onChange(hexInput);
  };

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs text-[#D7C7A1]/50">Background</span>

      <div className="flex items-center gap-1">
        {PRESETS.map((color) => (
          <button
            key={color}
            onClick={() => {
              onChange(color);
              setHexInput(color);
            }}
            title={color}
            className={`w-5 h-5 rounded border transition-transform hover:scale-110 ${
              backgroundColor === color ? "border-[#2F8F6F] scale-110" : "border-[#145A43]/60"
            }`}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>

      {/* custom color — swatch besar biar jelas ini "pick warna bebas", bukan cuma preset */}
      <label
        title="Pilih warna bebas"
        className="w-7 h-7 rounded border-2 border-[#145A43] overflow-hidden cursor-pointer relative shrink-0 hover:border-[#2F8F6F] transition-colors"
        style={{
          backgroundColor: !isTransparent ? backgroundColor : "transparent",
          backgroundImage: isTransparent
            ? "linear-gradient(45deg, #444 25%, transparent 25%), linear-gradient(-45deg, #444 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #444 75%), linear-gradient(-45deg, transparent 75%, #444 75%)"
            : "none",
          backgroundSize: "6px 6px",
          backgroundPosition: "0 0, 0 3px, 3px -3px, -3px 0",
        }}
      >
        <input
          type="color"
          value={isTransparent ? "#ffffff" : backgroundColor}
          onChange={(e) => {
            onChange(e.target.value);
            setHexInput(e.target.value);
          }}
          className="absolute inset-0 opacity-0 cursor-pointer w-full h-full"
        />
      </label>

      <input
        type="text"
        value={hexInput}
        onChange={(e) => setHexInput(e.target.value)}
        onBlur={handleHexSubmit}
        onKeyDown={(e) => e.key === "Enter" && handleHexSubmit()}
        placeholder="#hex"
        className="w-20 bg-[#0F0F0F] border border-[#145A43] rounded px-2 py-1 text-xs text-[#D7C7A1] focus:outline-none focus:border-[#2F8F6F]"
      />

      <button
        onClick={() => onChange(null)}
        title="Hapus background (transparan)"
        className={`text-xs px-2 py-1 rounded transition-colors ${
          isTransparent
            ? "bg-[#2F8F6F] text-[#0F0F0F]"
            : "bg-[#145A43] text-[#D7C7A1] hover:bg-[#2F8F6F] hover:text-[#0F0F0F]"
        }`}
      >
        Transparan
      </button>
    </div>
  );
}
